import safeLocalStorage from './utils/safeStorage';

const originalFetch = window.fetch;

window.fetch = async (resource, config = {}) => {
    const urlStr = typeof resource === 'string' ? resource : (resource?.url || '');

    // Skip Webpack dev server internal requests, hot-updates, and static bundle assets
    if (
        urlStr.includes('hot-update') ||
        urlStr.includes('/ws') ||
        (urlStr.includes('localhost:3000') && !urlStr.includes('/business/'))
    ) {
        return originalFetch(resource, config);
    }

    const businessId = safeLocalStorage.getItem('businessId');
    const newConfig = { ...config };

    if (!newConfig.headers) {
        newConfig.headers = {};
    }

    // Check if x-business-id is already set to avoid overwriting
    let hasBusinessId = false;
    if (typeof Headers !== 'undefined' && newConfig.headers instanceof Headers) {
        hasBusinessId = newConfig.headers.has('x-business-id');
    } else if (Array.isArray(newConfig.headers)) {
        hasBusinessId = newConfig.headers.some(h => h[0].toLowerCase() === 'x-business-id');
    } else if (typeof newConfig.headers === 'object') {
        hasBusinessId = !!Object.keys(newConfig.headers).find(k => k.toLowerCase() === 'x-business-id');
    }

    if (!hasBusinessId && businessId) {
        if (typeof Headers !== 'undefined' && newConfig.headers instanceof Headers) {
            newConfig.headers.set('x-business-id', businessId);
        } else if (Array.isArray(newConfig.headers)) {
            newConfig.headers.push(['x-business-id', businessId]);
        } else {
            newConfig.headers = {
                ...newConfig.headers,
                'x-business-id': businessId
            };
        }
    }

    return originalFetch(resource, newConfig);
};
